import { Button } from "@mui/material";

export default function FullyRoundedButton({
  buttonText = "",
  bgColor = "bg-blue-600",
  textColor = "text-white",
  horizontalPadding = "px-8",
  verticalPadding = "py-3",
  horizontalMargin = "mx-2",
  verticalMargin = "my-2",
  textSize = "text-sm",
  buttonWidth = "w-full",
  buttonHeight = "h-full",
  borderWidth = "border-[1px]",
  borderColor = "bg-blue-600",
  hoverBgColor = "bg-blue-700",
  hoverBorderColor = "border-blue-700",
  hoverBorderWidth = "border-[1px]",
  hoverTextColor = "text-white",
  variant = "contained",
  disabled = false,
  handleOnClick = {},
}) {
  return (
    <Button
      disableElevation
      disabled={disabled}
      variant={variant}
      className={`self-baseline rounded-full normal-case hover:cursor-pointer ${bgColor} ${horizontalPadding} ${verticalPadding} ${horizontalMargin} ${verticalMargin} ${textSize} ${textColor} ${buttonWidth} ${buttonHeight} ${borderWidth} ${borderColor} hover:${hoverBgColor} hover:${hoverTextColor} hover:${hoverBorderWidth} hover:${hoverBorderColor}`}
      sx={{
        "&:hover": {
          bgcolor: hoverBgColor,
          color: "text-blue-600",
          borderColor: hoverBorderColor,
          borderWidth: hoverBorderWidth,
        },
      }}
      onClick={() => handleOnClick()}
    >
      <span>{buttonText}</span>
    </Button>
  );
}
